var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.4 129.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ccc;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1_-_Outlined",
    "data-name": "1 - Outlined"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 24.41,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -12.06,
    y: 12.06,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67,
    transform: "translate(-12.06 23.4) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.06,
    y: 12.06,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67,
    transform: "translate(12.06 47.52) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.82,
    y: 4.67,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.82,
    y: 19.74,
    width: 79.58,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 47.08,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 71.49,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -12.06,
    y: 59.14,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67,
    transform: "translate(-59.14 70.48) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.06,
    y: 59.14,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67,
    transform: "translate(-35.02 94.6) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.82,
    y: 51.75,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.82,
    y: 66.82,
    width: 79.58,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 94.02,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 118.43,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -12.06,
    y: 106.08,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67,
    transform: "translate(-106.08 117.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.06,
    y: 106.08,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67,
    transform: "translate(-81.96 141.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.82,
    y: 98.69,
    width: 35.46,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.82,
    y: 113.76,
    width: 79.58,
    height: 11.34,
    rx: 5.67,
    ry: 5.67
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.38627e05e5d27653799a4591e9942e4d.svg";
export { ForwardRef as ReactComponent };